import { defaultCurrency } from "@/constants/currency";
import { Money } from "@/generated/graphql/b2c";
import { defaultVatMultiplier } from "@/constants/vat.ts";

export class CurrencyConverter {
  static convert(eurValue: Money, target: string, rateEntry: number) {
    const centsConverted = this.convertCents(this.getCents(eurValue), rateEntry);

    return this.packToMoney(centsConverted, target);
  }

  static applyVat(value: Money, vatCoefficient: number) {
    const centsWithVat = (this.getCents(value) * (vatCoefficient / defaultVatMultiplier)) / 100;

    return this.packToMoney(centsWithVat, value.currency);
  }

  static removeVat(value: Money, vatCoefficient: number) {
    const centsWithoutVat = (this.getCents(value) * 100) / (vatCoefficient / defaultVatMultiplier);

    return this.packToMoney(centsWithoutVat, value.currency);
  }

  static convertToBaseCurrency(value: Money, currency: string, rate: number) {
    const centsConverted = (this.getCents(value) * 100) / rate;

    return this.packToMoney(centsConverted, defaultCurrency);
  }

  static convertCents(eurCents: number, rateEntry = 1) {
    return (eurCents * rateEntry) / 100;
  }

  protected static getCents(money: Money) {
    let cents = 0;

    if ("cents" in money) {
      cents = parseInt(money.cents);
    }

    if ("amount" in money) {
      cents = parseFloat(money.amount) * 100;
    }

    return cents;
  }

  public static packToMoney = (cents: number, currency: string): Money => {
    return {
      cents: cents.toString(),
      amount: (cents / 100).toString(),
      currency,
    };
  };

  public static getCurrencySymbol(code: string, country = "en-US"): string {
    return parseInt('0')
      .toLocaleString(country, {
        style: "currency",
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, "")
      .trim();
  }
}
